import { StateCreator } from "zustand";

export interface QuestionSlice {
  lastQuestion: string | undefined;
  setLastQuestion: (lastQuestion: string | undefined) => void;
}

const createQuestionSlice: StateCreator<
  QuestionSlice,
  [],
  [],
  QuestionSlice
> = (set) => ({
  lastQuestion: undefined,
  setLastQuestion: (lastQuestion: string | undefined) => {
    set({ lastQuestion });
  },
});

export default createQuestionSlice;
